import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/frontend/app/components/CollectionCategoriesBox/CollectionCategoriesBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/frontend/app/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/frontend/app/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/frontend/app/components/NotFoundSplash/NotFoundSplash.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/frontend/app/components/ProjectCategoriesBox/ProjectCategoriesBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportDonioBanner"] */ "/home/circleci/project/frontend/app/components/SupportDonioBanner/SupportDonioBanner.tsx");
